import { makeStyles } from 'tss-react/mui'


const useStyles = makeStyles()((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
    }
}))

export default useStyles